import { render, staticRenderFns } from "./number.vue?vue&type=template&id=76b48fd7&lang=html"
import script from "./number.js?vue&type=script&lang=js&external"
export * from "./number.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports